import React from "react"
import moment from "moment";
import axios from "axios";
import { latest as API_URL, lastest_insecure as API_URL_INSECURE } from "../config/api";
import {  panels, formatDate } from "../config/Helpers";
import { Icon, Badge, Collapse, message, Popconfirm } from 'antd';

const postUrlReports = API_URL + "reports";
const postUrlReportsInsecure = API_URL_INSECURE + "reports";

class ListFixed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading_request_list : " hide",
            status : "",
            reports : {}
        }
        this.syncReports = this.syncReports.bind(this);
    }
    componentWillReceiveProps(props){
        const status = props.status;
        this.setState({
            status : status,
            reports : {}
        })
    }
    syncReports(){
        let self = this, CancelToken = axios.CancelToken, qs = require("qs");
        self.setState({
            loading_request_list : " "
        }, function(){
            axios({
                method : "POST",
                headers: { 'content-type' : 'application/x-www-form-urlencoded' },
                url : postUrlReports + "/list", 
                data : qs.stringify(self.props.currentFilters()),
                cancelToken : new CancelToken(function executor(c) {
                self.state.main_request_token_cancel = c;
                })
            }).then(function (response) {
                self.setState({
                    reports : response.data,
                    loading_request_list : " hide"
                })
            });
        });
    }
    deleteReport(_id_report){
        let self = this, CancelToken = axios.CancelToken, qs = require("qs");
        axios({
            method : "POST",
            headers: { 'content-type' : 'application/x-www-form-urlencoded' },
            url : postUrlReports + "/delete", 
            data : qs.stringify({
                api_token : localStorage.getItem('api_token'),
                _id_report : _id_report
            }),
            cancelToken : new CancelToken(function executor(c) {
            self.state.main_request_token_cancel = c;
            })
        }).then(function (response) {
            message.info('The report has been deleted')
            self.syncReports();
        });
    }
    setReport(_id_report, _is_interactive = false, _is_share = false, _is_invited = false, _allow_export = false, _dashboard_select){

        let self = this, 
        CancelToken = axios.CancelToken, 
        qs = require("qs"),
        URL = (_is_invited === true) ? postUrlReportsInsecure + "/get" : postUrlReports + "/get"

        self.setState({
            loading_request_list : " "
        },function(){
            axios({
                method : "POST",
                headers: { 'content-type' : 'application/x-www-form-urlencoded' },
                url : URL, 
                data : qs.stringify(self.props.app.currentFilters({ _id_report : _id_report })),
                
            }).then(function (response) {
                let datepicker = {
                    from : new Date(response.data['report'].filters.current_filter_dates[0]),
                    to : new Date(response.data['report'].filters.current_filter_dates[1])
                },
                datepicker_comp = {
                    from : new Date(response.data['report'].filters.current_filter_dates_comp[0]),
                    to : new Date(response.data['report'].filters.current_filter_dates_comp[1])
                },
                _LayoutReview = self.props.app._LayoutReview,
                _LayoutReservation = self.props.app._LayoutReservation,
                _LayoutLeadTime = self.props.app._LayoutLeadTime,
                _LayoutOccupancy = self.props.app._LayoutOccupancy,
                _widgetFiltersTime = self.props.app._widgetFiltersTime,
                _default_panel = (_is_share === false) ? self.props.app.state.panel : "",
                _params_module = {},
                _active_slide = {},
                _mode_report = self.props.app.state.mode_report;
                
                if(_is_share === false){
                    _mode_report = {
                        status : true,
                        _is_interactive : _is_interactive,
                        _is_share : _is_share,
                        _is_invited : false,
                        _dashboards_select : _dashboard_select,
                        _allow_export : _allow_export
                    }
                }

                Object.keys(panels).map((item) => {
                    Object.keys(_dashboard_select).map((key, index) => {
                        let _props_dashboard = JSON.parse(_dashboard_select[key])
                        if(panels[item]._value ===  _props_dashboard._panel){
                            if(_default_panel === ""){
                                _active_slide.index = _props_dashboard._index;;
                                _active_slide.dashboard = _props_dashboard._dashboard;
                                _active_slide.key = _props_dashboard._dashboard;
                                _default_panel = _props_dashboard._panel
                                _params_module = _props_dashboard._params_module
                            }
                        }
                    })
                });

                self.props.app.setState({
                    mode_report : _mode_report,
                    panel : _default_panel,
                    current_filter_reserve : response.data['report'].filters.current_filter_reserve,
                    current_filter : response.data['report'].filters.current_filter,
                    current_filter_properties : response.data['report'].filters.current_filter_properties,
                    current_filter_reserve : response.data['report'].filters.current_filter_reserve,
                    current_filter_brand : response.data['report'].filters.current_filter_brand,
                    current_filter_business : response.data['report'].filters.current_filter_business,
                    current_filter_plan : response.data['report'].filters.current_filter_plan,
                    current_filter_segment : response.data['report'].filters.current_filter_segment,
                    current_filter_type_room : response.data['report'].filters.current_filter_type_room,
                    current_filter_type_tariff : response.data['report'].filters.current_filter_type_tariff,
                    current_filter_channel : response.data['report'].filters.current_filter_channel,
                    current_filter_agency : response.data['report'].filters.current_filter_agency,
                    current_filter_market : response.data['report'].filters.current_filter_market,
                    current_filter_days : response.data['report'].filters.current_filter_days,
                    current_filter_dates : response.data['report'].filters.current_filter_dates,
                    current_filter_dates_comp : response.data['report'].filters.current_filter_dates_comp,
                    flash_summary_module : response.data['report'].filters.flash_summary_module,
                    type_date : response.data['report'].filters.type_date,
                    view_results : null,
                    report_context : {
                        _id : response.data['report']._id,
                        status : true,
                        className : 'report-context',
                        name : response.data['report'].name,
                        type : response.data['report'].type,
                        notify_email : response.data['report'].notify_email,
                        allow_export : response.data['report'].allow_export,
                        datepicker : response.data['report'].datepicker,
                        analysis_interval : response.data['report'].analysis_interval,
                        type_report : response.data['report'].type_report,
                        days_fixed_report : response.data['report'].days_fixed_report,
                        startValue : response.data['report'].startValue,
                        endValue : response.data['report'].endValue
                    },
                    _params_module : _params_module,
                    default_module_set : false
                }, function(){
                    
                    if(self.props.app.state.mode_report._is_share === true){
                        switch (_default_panel) {
                            case 'review':
                                _LayoutReview.setState({
                                    active_slide : _active_slide, 
                                    slides : {}
                                })
                                break;

                            case 'reservation':
                                _LayoutReservation.setState({
                                    active_slide : _active_slide, 
                                    slides : {}
                                });
                                break;

                            case 'lead-time':
                                _LayoutLeadTime.setState({
                                    active_slide : _active_slide, 
                                    slides : {}
                                });
                                break;

                            case 'occupancy':
                                _LayoutOccupancy.setState({
                                    active_slide : _active_slide, 
                                    slides : {}
                                });
                                break;

                            default:
                                break;
                        }
                    }
                    if(_LayoutReview._widgetByDate !== null){
                        _LayoutReview._widgetByDate.state.interval_time_selected = response.data['report'].filters.flash_summary_module.interval_time_selected
                    }
                    //Set Datepicker times
                    _widgetFiltersTime.setState({
                        datepicker,
                        datepicker_comp
                    }, function(){
                        self.props.app._ReportModel.state.datepicker = response.data['report'].datepicker;
                        self.props.app._ReportModel.state.notify_email = response.data['report'].notify_email;
                        self.props.app._ReportModel.state._allow_export = response.data['report'].allow_export;
                        self.setState({
                            loading_request_list : " hide"
                        }, function(){
                            self.props.layout.confirm(true)
                        })
                    })
                })
            });
        })
    }
    render = () => {
        let self = this;
        const Panel = Collapse.Panel;
        const list_reports = Object.keys(this.state.reports).map(function(key){
            let emails_share = (self.state.reports[key].report_share[0] !== undefined) ? 
                self.state.reports[key].report_share[0].emails : {};
            let is_interactive = (self.state.reports[key].report_share[0] !== undefined) ? 
                ((self.state.reports[key].report_share[0].dinamyc_report === 1) ? true : false) : false;

            let dashboards_select = (self.state.reports[key].report_share[0] !== undefined) ? 
                self.state.reports[key].report_share[0].dashboards_select : false;

                let created = formatDate(new Date(parseInt(self.state.reports[key].created.$date.$numberLong)));
                let last_updated = formatDate(new Date(parseInt(self.state.reports[key].last_updated.$date.$numberLong)));
            return (
                <div>
                    <div className="info">
                        <span className="title-report">{self.state.reports[key].name}</span>
                        <div>
                            <span>CREATED: { created }</span>
                            <span>LAST UPDATE: { last_updated }</span>
                        </div>
                    </div>
                    <div className="options">
                        { (self.state.reports[key]._is_share === false) ? 
                            (<Badge count={ Object.keys(emails_share).length }>
                                <Icon type="share-alt" style={{fontSize : 20, verticalAlign : "middle", color : "#4da1ff", marginLeft : 10 }}/>
                            </Badge>) : null
                        }
                        { (self.state.reports[key]._is_share === false) ? 
                            (<Icon
                                type="edit" 
                                onClick={self.setReport.bind(self, self.state.reports[key]._id, true, false, false, false, {})} 
                                theme="outlined" 
                                style={{fontSize : 20, verticalAlign : "middle", color : "#4da1ff", marginLeft : 10}} 
                            />) : 
                            (<Icon
                                type="eye" 
                                onClick={self.setReport.bind(self, self.state.reports[key]._id, is_interactive, true, false, false, dashboards_select)} 
                                theme="outlined" 
                                style={{fontSize : 20, verticalAlign : "middle", color : "#4da1ff", marginLeft : 10}} 
                            />) 
                        }
                        { (self.state.reports[key]._is_share === false ) ? 
                            (<Popconfirm placement="bottom" title="Are you sure to delete this report？" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={self.deleteReport.bind(self, self.state.reports[key]._id)}>
                                <Icon
                                    type="delete" 
                                    theme="outlined" 
                                    style={{fontSize : 20, verticalAlign : "middle", color : "#4da1ff", marginLeft : 10}} 
                                />
                            </Popconfirm>
                            ) : null
                        }

                    </div>
                </div>
            );
        })
        return(
            <div className={ "list-reports " + this.state.status }> 
                <div className={"request-loading " + this.state.loading_request_list }>
                    <Icon type="loading" theme="outlined" />
                </div>
                {
                    (list_reports.length > 0) ? 
                        list_reports : 
                        <span style={{
                            lineHeight : '30px',
                            width : '260px',
                            display : 'inline-block',
                            position : 'absolute',
                            right : '50%',
                            marginRight : '-130px',
                            top : '50%',
                            marginTop : '-15px',
                            textAlign : 'center',
                            fontSize: '20px',
                            color: '#CCC',
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            letterSpacing: '1px'
                        }} children="REPORTS NOT FOUND" />
                }
            </div>
        )
    }
}

export default ListFixed;


// WEBPACK FOOTER //
// ./src/Frontend/reports/ListFixed.js